import { useState } from 'react'
import classNames from 'classnames/bind'

import { PlainColumns } from 'app/common/ui/PlainGrid'
import PlainLabel from 'app/common/ui-next/plain-label'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { useCompensationEnabledByStudent } from 'app/dataProviders/user/hooks'

import styles from '../CompensationInfo.scss'
import { CompensationHistory } from '../../CompensationHistory'


const cx = classNames.bind(styles)

type Props = {
  linkToChildrenAccount: string
  linkToParentAccount: string
  studentID: string
  supplierID: string | null
}
export const CompensationAccountInfo = ({
  linkToChildrenAccount,
  linkToParentAccount,
  studentID,
  supplierID,
}: Props) => {
  const [isOpenHistory, setOpenHistory] = useState<boolean>(false)

  const {
    compensationByStatement,
    compensationByCabinet,
  } = useCompensationEnabledByStudent(studentID)

  return (
    <PlainColumns className={cx(styles.row)}>
      <PlainLabel id="buttons" className={styles.itemInfo}>
        {'Вывести компенсацию на:'}
      </PlainLabel>

      <ControlsBar className={styles.button}>
        {compensationByCabinet
          && <PlainLinkAsButton to={linkToChildrenAccount} disabled>
            {'Счет ребенка'}
          </PlainLinkAsButton>}
        {compensationByStatement
          && <PlainLinkAsButton to={linkToParentAccount}>
            {'Р/С родителя'}
          </PlainLinkAsButton>}
        <PlainButton
          className={styles.button}
          onClick={() => setOpenHistory(true)}
          outline
        >
          {'История операций'}
        </PlainButton>
      </ControlsBar>

      {isOpenHistory && <CompensationHistory
        onCrossClick={() => setOpenHistory(false)}
        studentID={studentID}
        supplierID={supplierID}
      />}
    </PlainColumns>
  )
}
